import { DEFAULT_SEARCH_INDEX } from 'lib/util/algolia';
import { classnames } from 'tailwindcss-classnames';
import { SortBy } from 'react-instantsearch-hooks-web';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSearchDictionary } from '../../util';
import { SearchWrapperProps } from '../../SearchTypes';

interface SearchSortWrapperProps extends SearchWrapperProps {
  sortLabel: string;
}

const SearchSortWrapper = ({ children, sortLabel }: SearchSortWrapperProps) => {
  return (
    <div className={classnames('flex', 'items-center', 'mb-4', 'sm:mb-2')}>
      <span
        className={classnames(
          'text-blue-navy',
          'text-body',
          'font-medium',
          'mr-6',
          'min-w-[50px]',
          'text-sm',
          'text-black',
          'lg:min-w-0'
        )}
      >
        {sortLabel}
      </span>
      {children}
    </div>
  );
};

const SearchSortWithSearch = () => {
  const dict = useSearchDictionary();
  return (
    <SearchSortWrapper sortLabel={dict.sort}>
      <SortBy
        classNames={{
          root: classnames('w-full'),
          select: classnames(
            'border',
            'border-gray-spunPearl',
            'rounded-md',
            'p-2',
            'w-full',
            'text-sm',
            'text-black'
          ),
        }}
        items={[
          { label: dict.sortNewest, value: `${DEFAULT_SEARCH_INDEX}_date_desc` },
          { label: dict.sortOldest, value: `${DEFAULT_SEARCH_INDEX}_date_asc` },
          { label: dict.sortNameAsc, value: `${DEFAULT_SEARCH_INDEX}_name_asc` },
          { label: dict.sortNameDesc, value: `${DEFAULT_SEARCH_INDEX}_name_desc` },
        ]}
      />
    </SearchSortWrapper>
  );
};

const ProductListSort = () => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    const theSortLabel = 'Search Sort';
    return <SearchSortWrapper sortLabel={theSortLabel} />;
  }
  return <SearchSortWithSearch />;
};

export default ProductListSort;
